
export const isEmailValid = ( value: string ) => {
  return value.length > 0
}